import Vue from 'vue'
import Router from 'vue-router'
import CreateConsent from "@/mfu/components/CreateConsent";

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')
const DefaultContainer2 = () => import('@/containers/DefaultContainer_2')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/Charts')
const Widgets = () => import('@/views/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const Flags = () => import('@/views/icons/Flags')
const FontAwesome = () => import('@/views/icons/FontAwesome')
const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts');
const Badges = () => import('@/views/notifications/Badges');
const Modals = () => import('@/views/notifications/Modals');

// Views - Pages
const Page404 = () => import('@/views/pages/Page404');
const Page500 = () => import('@/views/pages/Page500');
const Login = () => import('@/views/pages/Login');
const Register = () => import('@/views/pages/Register');

// Users
const Users = () => import('@/views/users/Users');
const User = () => import('@/views/users/User');

const CreateNews = () => import('@/mfu/views/student/index');
const CreateBio = () => import('@/mfu/views/student/bio');
//const CreateBioPart7 = () => import('@/mfu/views/student/biopart7');
const CreateGeneral = () => import('@/mfu/views/student/general');
const CreatePart1 = () => import('@/mfu/views/student/part1');
const CreatePart2 = () => import('@/mfu/views/student/part2');
const CreatePart2_2 = () => import('@/mfu/views/student/part2_2');
const CreatePart2_3 = () => import('@/mfu/views/student/part2_3');
const CreatePart3 = () => import('@/mfu/views/student/part3');
const CreatePart4 = () => import('@/mfu/views/student/part4');
const CreatePart5 = () => import('@/mfu/views/student/part5');
const CreatePart10 = () => import('@/mfu/views/student/part10');
const CreatePart10_2 = () => import('@/mfu/views/student/part10_2');
const CreatePart10_3 = () => import('@/mfu/views/student/part10_3');
const CreatePart10_4 = () => import('@/mfu/views/student/part10_4');
const CreatePart10_5 = () => import('@/mfu/views/student/part10_5');
const CreatePart10_6 = () => import('@/mfu/views/student/part10_6');
const CreatePart10_7 = () => import('@/mfu/views/student/part10_7');
const CreatePart10_8 = () => import('@/mfu/views/student/part10_8');
const CreatePart10_9 = () => import('@/mfu/views/student/part10_9');
const CreatePart10_10 = () => import('@/mfu/views/student/part10_10');
const CreatePart10_11 = () => import('@/mfu/views/student/part10_11');
const CreateDetailpart10= () => import('@/mfu/views/student/detailpart10');
const CreateDetailpart10_2= () => import('@/mfu/views/student/detailpart10_2');
const CreateDetailpart10_3= () => import('@/mfu/views/student/detailpart10_3');
//const CreatePart7detail = () => import('@/mfu/views/student/part7detail');
const CreateRadio = () => import('@/mfu/views/student/Radio');
const CreateSelect = () => import('@/mfu/views/student/Select');
const CreateCheckbox = () => import('@/mfu/views/student/Checkbox');
const CreateRegis = () => import('@/mfu/views/student/regis');
const CreateCon = () => import('@/mfu/views/student/consent');

//const CreateRegis_62 = () => import('@/mfu/views/student/regis_62');
//const CreateRegis_63 = () => import('@/mfu/views/student/regis_63');
const CreateRegisdetail = () => import('@/mfu/views/student/regisdetail');
//const CreateRegisdetail_62 = () => import('@/mfu/views/student/regisdetail_62');
// const CreateRegisdetail_63 = () => import('@/mfu/views/student/regisdetail_63');

const CreateLogin = () => import('@/mfu/views/student/login');
// const CreateLogin_64 = () => import('@/mfu/views/student/login_64');
// const CreateLogin_63 = () => import('@/mfu/views/student/login_63');
// const CreateLogin_test = () => import('@/mfu/views/student/login_test'); google
//const CreateLogin_62 = () => import('@/mfu/views/student/login_62');
const CreateDashboard = () => import('@/mfu/views/student/dashboard');
const CreateMain = () => import('@/mfu/views/student/main');
const CreateMain70 = () => import('@/mfu/views/student/main70');
//const CreateDashboard_62 = () => import('@/mfu/views/student/dashboard_62');
// const CreateDashboard_63 = () => import('@/mfu/views/student/dashboard_63');
const CreateEmployment = () => import('@/mfu/views/student/employment');
const CreateEmployment2 = () => import('@/mfu/views/student/employment2');
const CreateEmployment3 = () => import('@/mfu/views/student/employment3');
const CreateEmployment4 = () => import('@/mfu/views/student/employment4');
const CreateEmployment5 = () => import('@/mfu/views/student/employment5');
const CreateThank = () => import('@/mfu/views/student/thank');
// const CreateThank_63 = () => import('@/mfu/views/student/thank_63');
const CreateIntro= () => import('@/mfu/views/student/intro');
const CreateExcelcomp= () => import('@/mfu/views/student/excelcomp');
const CreateExcelincomp= () => import('@/mfu/views/student/excelincomp');
const CreateExcelnotregis= () => import('@/mfu/views/student/excelnotregis');

// const CreateThank_62 = () => import('@/mfu/views/student/thank_62');
// const CreateQ3r7c = () => import('@/mfu/views/student/q3r7c');
// const CreateQ3r7c_2 = () => import('@/mfu/views/student/q3r7c_2');
// const CreateQ3r7c_3 = () => import('@/mfu/views/student/q3r7c_3');
// const CreateQ3r7c_4 = () => import('@/mfu/views/student/q3r7c_4');
// const CreateQ3r7cdetail = () => import('@/mfu/views/student/q3r7cdetail');
// const CreateSkills5 = () => import('@/mfu/views/student/skills5');
// const CreateSkills5_2 = () => import('@/mfu/views/student/skills5_2');
// const CreateSkills5_3 = () => import('@/mfu/views/student/skills5_3');
const CreateSkills5detail = () => import('@/mfu/views/student/skills5detail');
// const CreateQa = () => import('@/mfu/views/student/qa');
// const CreateQadetail = () => import('@/mfu/views/student/qadetail');
const CreatePost = () => import('@/mfu/views/student/post');
const CreatePostdetail = () => import('@/mfu/views/student/postdetail');
// const CreatePost_62 = () => import('@/mfu/views/student/post_62');
const CreatePost_63 = () => import('@/mfu/views/student/post_63');
const CreatePost_80 = () => import('@/mfu/views/student/post_80');
const CreatePerson = () => import('@/mfu/views/student/person');
const CreateRegispost = () => import('@/mfu/views/student/regispost');
const CreateAuthorized = () => import('@/mfu/views/student/authorized.vue');
// const CreateConfirm = () => import('@/mfu/views/student/confirm.vue');
//const CreateConfirm_62 = () => import('@/mfu/views/student/confirm_62.vue');
const CreateConfirm = () => import('@/mfu/views/student/confirm.vue');
// const Logout = () => import('@/mfu/views/student/logout.vue');
const Logout = () => import('@/mfu/views/student/logout');
const CreatePay = () => import('@/mfu/views/student/pay.vue');
const CreateRead = () => import('@/mfu/views/student/read.vue');
const CreateIndex = () => import('@/mfu/views/student/index.vue');
const CreateIndex_eng = () => import('@/mfu/views/student/index_eng.vue');

const CreateGraduate = () => import('@/mfu/views/student/graduate.vue');
const CreateReportdate = () => import('@/mfu/views/student/reportdate.vue');
// const CreateReportdate_63 = () => import('@/mfu/views/student/reportdate_63.vue');
const CreateReportfaculty = () => import('@/mfu/views/student/reportfaculty.vue');
// const CreateReportfaculty_62 = () => import('@/mfu/views/student/reportfaculty_62.vue');
// const CreateReportfaculty_63 = () => import('@/mfu/views/student/reportfaculty_63.vue');
const CreateReportdept = () => import('@/mfu/views/student/reportdept.vue');
const CreateReportdept_62 = () => import('@/mfu/views/student/reportdept_62.vue');
const CreateReporttype = () => import('@/mfu/views/student/reporttype.vue');
const CreateReportcompleted = () => import('@/mfu/views/student/reportcompleted.vue');
const CreateReportattend = () => import('@/mfu/views/student/reportattend.vue');
const  CreateReportnotattend = () => import('@/mfu/views/student/reportnotattend.vue');
const CreateReportincompleted = () => import('@/mfu/views/student/reportincompleted.vue');
const CreateReportincompleted_eng = () => import('@/mfu/views/student/reportincompleted_eng.vue');
const CreateReporttypeforeigners = () => import('@/mfu/views/student/reporttypeforeigners.vue');
const CreateReporttypechinese = () => import('@/mfu/views/student/reporttypechinese.vue');
const CreateReportnotregis = () => import('@/mfu/views/student/reportnotregis.vue');
const CreateReportnotregisforeigners = () => import('@/mfu/views/student/reportnotregisforeigners.vue');
const CreateSearch = () => import('@/mfu/views/student/search.vue');


//const IndexNew = () => import('@/mfu/views/index');
Vue.use(Router)

export default new Router({
  data() {
    return {
      date1: "tes"
    }
  },
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
    path: '/',
    redirect: '/index',
    // redirect: '/login',
    name: 'Pages',
    component: {
      render(c) {
        return c('router-view')
      }
    },
    children: [{
      path: '404',
      name: 'Page404',
      component: Page404
    },
      {
        path: '500',
        name: 'Page500',
        component: Page500
      },
     {
        path: 'login',
        name: 'Login',
        component: CreateLogin
      },
      {
        path: 'register',
        name: 'Register',
        component: Register
      }, {
        path: '/Index',
        name: 'Index',
        component: CreateIndex
      },
        /*{
        path: '/Indexx',
        name: 'Index',
        component: IndexNew
      },*/

      {
        path: '/Index_eng',
        name: 'Index_eng',
        component: CreateIndex_eng
      }, {
        path: '/Thank',
        name: 'Thank',
        component: CreateThank
      },
      {
        path: '/Intro',
        name: 'Intro',
        component: CreateIntro
      },
      {
        path: '/Excelcomp',
        name: 'Excelcomp',
        component: CreateExcelcomp
      },
      {
        path: '/Excelincomp',
        name: 'Excelincomp',
        component: CreateExcelincomp
      },
      {
        path: '/Excelnotregis',
        name: 'Excelnotregis',
        component: CreateExcelnotregis
      },
      // {
      //   path: '/Thank_63',
      //   name: 'Thank_63',
      //   component: CreateThank_63
      // },
    ]
  },
    {
      path: '/reports',
      redirect: '/Reportdate',
      name: 'หน้าหลัก',
      nameth: "หน้าหลัก",
      component: DefaultContainer2,
      children: [{
        path: '/Search',
        name: 'Search',
        component: CreateSearch
      },
        {
          path: '/Reportdate',
          name: 'Reportdate',
          component: CreateReportdate
        },

        {
          path: '/Graduate',
          name: 'Graduate',
          component: CreateGraduate
        },
        {
          path: '/Reportattend',
          name: 'Reportattend',
          component: CreateReportattend
        },
        {
          path: '/Reportnotattend',
          name: 'Reportnotattend',
          component: CreateReportnotattend
        },
        {
          path: '/Reportfaculty',
          name: 'Reportfaculty',
          component: CreateReportfaculty
        },
        // {
        //   path: '/Reportfaculty_63',
        //   name: 'Reportfaculty_63',
        //   component: CreateReportfaculty_63
        // },
        // {
        //   path: '/Reportfaculty_62',
        //   name: 'Reportfaculty_62',
        //   component: CreateReportfaculty_62
        // },
        {
          path: '/Reportdept',
          name: 'Reportdept',
          component: CreateReportdept
        },
        // {
        //   path: '/Reportdept_62',
        //   name: 'Reportdept_62',
        //   component: CreateReportdept_62
        // },
        {
          path: '/Reporttype',
          name: 'Reporttype',
          component: CreateReporttype
        },

        {
          path: '/Reportcompleted',
          name: 'Reportcompleted',
          component: CreateReportcompleted
        },
        // {
        //   path: '/Reportcompleted_63',
        //   name: 'Reportcompleted_63',
        //   component: CreateReportcompleted_63
        // },
        {
          path: '/Reportincompleted',
          name: 'Reportincompleted',
          component: CreateReportincompleted
        }, {
          path: '/Reporttypeforeigners',
          name: 'Reporttypeforeigners',
          component: CreateReporttypeforeigners
        }, {
          path: '/Reportnotregis',
          name: 'Reportnotregis',
          component: CreateReportnotregis
        }, {
          path: '/Reportnotregisforeigners',
          name: 'Reportnotregisforeigners',
          component: CreateReportnotregisforeigners
        }, {
          path: '/Reportincompleted_eng',
          name: 'Reportincompleted_eng',
          component: CreateReportincompleted_eng
        }, {
          path: '/Reporttypechinese',
          name: 'Reporttypechinese',
          component: CreateReporttypechinese
        }



      ]
    },
    {
      path: '/Main',
      redirect: '/Main',
      name: 'Main1',
      nameth: "ทักษะในศตวรรษที่",
      component: DefaultContainer,
      children: [
        {
          path: '/Regispost',
          name: 'Regispost',
          component: CreateRegispost
        },
        {
          path: '/General',
          name: 'ภาวะการมีงานทำ',
          component: CreateGeneral
        },
        {
          path: '/Employment',
          name: 'Employment',
          component: CreateEmployment
        },
        {
          path: '/Employment3',
          name: 'Employment3',
          component: CreateEmployment3
        },
        {
          path: '/Employment2',
          name: 'Employment2',
          component: CreateEmployment2
        },
        {
          path: '/Employment4',
          name: 'Employment4',
          component: CreateEmployment4
        },
        {
          path: '/Employment5',
          name: 'Employment5',
          component: CreateEmployment5
        },
        {
          path: '/Person',
          name: 'Person',
          component: CreatePerson
        },
        {
          path: '/Part1',
          name: 'ตอนที่ 1 ข้อมูลทั่วไป',
          component: CreatePart1
        },
        {
          path: '/Part2',
          name: 'ตอนที่ 2 สำหรับผู้ที่ทำงานแล้ว',
          component: CreatePart2
        },
        {
          path: '/Part2_2',
          name: 'Part2_2',
          component: CreatePart2_2
        },
        {
          path: '/Part2_3',
          name: 'Part2_3',
          component: CreatePart2_3
        },
        {
          path: '/Part3',
          name: 'ตอนที่ 3 สำหรับผู้ที่ยังไม่ทำงาน',
          component: CreatePart3
        }, {
          path: '/Part4',
          name: 'ตอนที่ 4 การศึกษาต่อ',
          component: CreatePart4
        }, {
          path: '/Part5',
          name: 'ตอนที่ 5 ข้อเสนอแนะ',
          component: CreatePart5
        },
         {
          path: '/Part10',
          name: 'Part10',
          component: CreatePart10
        },
      {
          path: '/Part10_2',
          name: 'Part10_2',
          component: CreatePart10_2
        },
        {
          path: '/Part10_3',
          name: 'Part10_3',
          component: CreatePart10_3
        },
           {
              path: '/Part10_4',
              name: 'Part10_4',
              component: CreatePart10_4
            },
        {
          path: '/Part10_5',
          name: 'Part10_5',
          component: CreatePart10_5
        },
         {
          path: '/Part10_6',
          name: 'Part10_6',
          component: CreatePart10_6
        },
         {
           path: '/Part10_7',
           name: 'Part10_7',
           component: CreatePart10_7
         },
        {
          path: '/Part10_8',
          name: 'Part10_8',
          component: CreatePart10_8
        },
        {
          path: '/Part10_9',
          name: 'Part10_9',
          component: CreatePart10_9
        },
        {
          path: '/Part10_10',
          name: 'Part10_10',
          component: CreatePart10_10
        },
        {
          path: '/Part10_11',
          name: 'Part10_11',
          component: CreatePart10_11
        },
        /*{
          path: '/Part7detail',
          name: 'Part7detail',
          component: CreatePart7detail
        },*/
        {
          path: '/Detailpart10',
          name: 'Detailpart10',
          component: CreateDetailpart10
        },
        {
          path: '/Detailpart10_2',
          name: 'Detailpart10_2',
          component: CreateDetailpart10_2
        },
        {
          path: '/Detailpart10_3',
          name: 'Detailpart10_3',
          component: CreateDetailpart10_3
        },
       {
          path: '/Regis',
          name: 'Regis',
          component: CreateRegis
        },
        {
          path: '/Con',
          name: 'Con',
          component: CreateCon
        },
        {
          path: '/Post',
          name: 'Post',
          component: CreatePost
        },
        {
          path: '/Postdetail',
          name: 'Postdetail',
          component: CreatePostdetail
        },
        // {
        //   path: '/Post_80',
        //   name: 'Post_80',
        //   component: CreatePost_80
        // },
        {
          path: '/Radio',
          name: 'Radio',
          component: CreateRadio
        }, {
          path: '/Checkbox',
          name: 'Checkbox',
          component: CreateCheckbox
        }, {
          path: '/Select',
          name: 'Select',
          component: CreateSelect
        },
        {
          path: '/Main',
          name: 'Main',
          component: CreateMain
        },
        {
          path: '/Main70',
          name: 'Main70',
          component: CreateMain70
        },
        // {
        //   path: '/Dashboard',
        //   name: 'Dashboard',
        //   component: CreateDashboard
        // },
        {
          path: '/Authorized',
          name: 'Authorized',
          component: CreateAuthorized
        },
        {
          path: '/Confirm',
          name: 'Confirm',
          component: CreateConfirm
        },
        {
          path: '/Logout',
          name: 'Logout',
          component: Logout
        },
        // {
        //   path: '/Login',
        //   name: 'Login',
        //   component: Login
        // },
        {
          path: '/Pay',
          name: 'Pay',
          component: CreatePay
        },
        {
          path: '/Regisdetail',
          name: 'Regisdetail',
          component: CreateRegisdetail
        },
        // {
        //   path: '/Regisdetail_63',
        //   name: 'Regisdetail_63',
        //   component: CreateRegisdetail_63
        // }
        , {
          path: '/Read',
          name: 'Read',
          component: CreateRead
        }
        ,
        // {
        //   path: '/Read_62',
        //   name: 'Read_62',
        //   component: CreateRead_62
        // }
        /*,  {
           path: '/BioPart7',
           name: 'BioPart7',
           component: CreateBioPart7
         }*/
         , {
           path: '/Bio',
           name: 'Bio',
           component: CreateBio
         }
      ]
    },

  ]
})
